var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWechat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-we-chat-gold"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "we-chat-gold",
    clipPath: "url(#clip-we-chat-gold)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#998242"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wechat",
    transform: "translate(-17.933 -34.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(19.582 37.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M39.524,46.059a10.183,10.183,0,0,0-6.862,2.772,8.149,8.149,0,0,0-2.531,6.9c-1.041-.129-1.99-.271-2.944-.351a1.829,1.829,0,0,0-1,.169c-.926.523-1.814,1.113-2.867,1.771.193-.874.318-1.638.539-2.374a.9.9,0,0,0-.411-1.194c-3.2-2.258-4.547-5.638-3.538-9.117a9.025,9.025,0,0,1,6.341-6.188,10.63,10.63,0,0,1,11.615,3.4,7.956,7.956,0,0,1,1.658,4.206ZM27.261,44.974a1.228,1.228,0,0,0-1.182-1.229A1.193,1.193,0,0,0,24.837,44.9a1.179,1.179,0,0,0,1.168,1.224A1.213,1.213,0,0,0,27.261,44.974Zm6.4-1.229a1.23,1.23,0,0,0-1.2,1.211,1.2,1.2,0,0,0,1.233,1.172,1.192,1.192,0,1,0-.032-2.383Z",
    transform: "translate(-19.582 -37.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M139.32,136.453a9.048,9.048,0,0,0-2.442-1.025,13.656,13.656,0,0,0-2.542.476,8.5,8.5,0,0,1-6.892-2.248c-3.675-3.4-3.15-8.611,1.1-11.4,3.779-2.476,9.321-1.65,11.985,1.785a6.807,6.807,0,0,1-.787,9.495c-.821.729-1.117,1.329-.59,2.289A2.725,2.725,0,0,1,139.32,136.453Zm-9.6-9.3a.993.993,0,1,0,.007-1.985.993.993,0,1,0-.007,1.985Zm6.191-1.983a.993.993,0,0,0-.985.95.979.979,0,1,0,.985-.95Z",
    transform: "translate(-113.392 -111.703)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.701d67198cfcb23bc8b1ea2323a78136.svg";
export { ForwardRef as ReactComponent };